import { DrawingPad, type DrawingPadHandle } from '../../components/DrawingPad/index.js';
import styles from './PlaceValueSection.module.css';

export interface PlaceValueSectionProps {
  registerPad: (handle: DrawingPadHandle | null) => void;
  /** When false, render the pads as plain shells so the board's pen
   *  overlay can annotate them directly. */
  drawingEnabled?: boolean;
}

const EXPANDED = [
  { key: 'expanded-hundreds', width: 220 },
  { key: 'expanded-tens', width: 180 },
  { key: 'expanded-ones', width: 140 },
] as const;

/**
 * Expanded-form drawing pads — h + t + o with a "+" between each
 * slot. The base-10 block model (hundred / ten / one manipulatives)
 * now lives in ManipulativesSection, which renders the same place-
 * value information as touchable blocks rather than write-in pads.
 */
export function PlaceValueSection({ registerPad, drawingEnabled = true }: PlaceValueSectionProps) {
  return (
    <section className={styles.section} data-testid="place-value-section">
      <h2>Expanded form</h2>
      <div className={styles.expandedRow} data-testid="expanded-form-pads">
        {EXPANDED.map((p, i) => (
          <span key={p.key} className={styles.expandedItem}>
            <DrawingPad
              ref={drawingEnabled ? registerPad : undefined}
              width={p.width}
              height={140}
              ariaLabel={`Expanded form pad ${i + 1}`}
              disabled={!drawingEnabled}
            />
            {i < EXPANDED.length - 1 ? <span className={styles.plus}>+</span> : null}
          </span>
        ))}
      </div>
    </section>
  );
}
